/**
 * Service for fetching What's New HTML content
 * Loads from bundled HTML files
 */

// Import HTML files as raw text
import fallbackHTML from "../../whats-new/fallback.html?raw";
import v1_2_4_HTML from "../../whats-new/v1.2.4.html?raw";
import v1_2_5_HTML from "../../whats-new/v1.2.5.html?raw";
import v1_2_6_HTML from "../../whats-new/v1.2.6.html?raw";
import v1_2_7_HTML from "../../whats-new/v1.2.7.html?raw";
import v1_2_9_HTML from "../../whats-new/v1.2.9.html?raw";
import v1_2_9_2_HTML from "../../whats-new/v1.2.9.2.html?raw";
import v1_3_0_1_HTML from "../../whats-new/v1.3.0.1.html?raw";
import v1_3_0_2_HTML from "../../whats-new/v1.3.0.2.html?raw";
import v1_3_0_3_HTML from "../../whats-new/v1.3.0.3.html?raw";
import v1_3_0_4_HTML from "../../whats-new/v1.3.0.4.html?raw";
import v1_3_0_5_HTML from "../../whats-new/v1.3.0.5.html?raw";
import v1_3_0_6_HTML from "../../whats-new/v1.3.0.6.html?raw";
import v1_4_0_HTML from "../../whats-new/v1.4.0.html?raw";
import v1_4_1_HTML from "../../whats-new/v1.4.1.html?raw";
import v1_4_2_HTML from "../../whats-new/v1.4.2.html?raw";
import v1_4_3_HTML from "../../whats-new/v1.4.3.html?raw";
import v1_4_4_HTML from "../../whats-new/v1.4.4.html?raw";
import v1_4_5_HTML from "../../whats-new/v1.4.5.html?raw";

// Version mapping
const VERSION_HTML_MAP = {
  "1.2.4": v1_2_4_HTML,
  "1.2.5": v1_2_5_HTML,
  "1.2.6": v1_2_6_HTML,
  "1.2.7": v1_2_7_HTML,
  "1.2.9": v1_2_9_HTML,
  "1.2.9.2": v1_2_9_2_HTML,
  "1.3.0.1": v1_3_0_1_HTML,
  "1.3.0.2": v1_3_0_2_HTML,
  "1.3.0.3": v1_3_0_3_HTML,
  "1.3.0.4": v1_3_0_4_HTML,
  "1.3.0.5": v1_3_0_5_HTML,
  "1.3.0.6": v1_3_0_6_HTML,
  "1.4.0": v1_4_0_HTML,
  "1.4.1": v1_4_1_HTML,
  "1.4.2": v1_4_2_HTML,
  "1.4.3": v1_4_3_HTML,
  "1.4.4": v1_4_4_HTML,
  "1.4.5": v1_4_5_HTML,
};

/**
 * Get default hardcoded HTML template (last resort)
 */
const getDefaultHTML = () => {
  return `
    <div class="whats-new-remote-content">
      <section class="whats-new-hero">
        <div class="hero-icon">✨</div>
        <h2>Bem-vindo ao Odin Sight</h2>
        <p>
          Obrigado por usar o Odin Sight! Esta é uma plataforma de análise
          técnica profissional para o mercado brasileiro.
        </p>
      </section>

      <section class="whats-new-section">
        <h3>
          <span class="section-icon">🎉</span>
          Novidades
        </h3>
        <p>
          Não foi possível carregar as novidades desta versão.
          Verifique sua conexão com a internet.
        </p>
      </section>

      <section class="whats-new-cta">
        <a href="https://github.com/gutoperes/odin-sight/blob/main/docs/CHANGELOG.md" target="_blank" rel="noopener noreferrer">
          📖 Ver Changelog Completo
        </a>
      </section>
    </div>
  `;
};

/**
 * Main function to fetch What's New HTML content
 *
 * Strategy:
 * 1. Check if version exists in bundle
 * 2. Return bundled HTML
 * 3. Fall back to default template
 */
export const fetchWhatsNewHTML = async (version) => {
  console.log(`[WhatsNewService] Loading What's New for version ${version}`);

  try {
    // Check if we have bundled HTML for this version
    if (VERSION_HTML_MAP[version]) {
      console.log(
        `[WhatsNewService] Found bundled HTML for version ${version}`,
      );
      return VERSION_HTML_MAP[version];
    }

    // Fall back to fallback HTML
    console.log(
      `[WhatsNewService] No bundled HTML for version ${version}, using fallback`,
    );
    return fallbackHTML || getDefaultHTML();
  } catch (error) {
    console.error("[WhatsNewService] Failed to load What's New HTML:", error);
    return getDefaultHTML();
  }
};

export default {
  fetchWhatsNewHTML,
};
